import { SelectChangeEvent } from "@mui/material";
import { IOption } from "components/MainSelect/MainSelectInterfaces";
import { Order } from "components/MainTable/components/EnhancedTableHead/EnhancedTableHeadInterfaces";
import { IGetLocalserverStatusDetailsReturn } from "entities/MillLocalserver/MillLocalserverEntityInterfaces";

export interface IMillNetworkDetailsContext {
    rangeFilterOptions: IOption[];
    rangeSelected: number;
    handleRangeSelection: (event: SelectChangeEvent<number>) => void;
    statusAverages: IGetLocalserverStatusDetailsReturn["statusAverages"];
    statusReports: IGetLocalserverStatusDetailsReturn["statusReports"];
    loading: boolean;
    refetch: () => Promise<void>;
    statusReportsTableResources: {
        handleRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
        handleChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void;
        handleChangePage: (event: unknown, newPage: number) => void;
        order: Order;
        orderBy: string;
        page: number;
        rowsPerPage: number;
    };
}

export interface IMillNetworkDetailsContextProps {
    children: React.ReactNode;
}

export enum RangeLabelEnum {
    HOURS = "hours",
    WEEK = "week",
}

export const RangeHours = {
    "24_HOURS": { value: 24, label: RangeLabelEnum.HOURS },
    "48_HOURS": { value: 48, label: RangeLabelEnum.HOURS },
    "168_HOURS": { value: 168, label: RangeLabelEnum.WEEK },
};

export type RangeHoursValue = (typeof RangeHours)[keyof typeof RangeHours];
